export default __webpack_public_path__ + "static/media/referral.497b0ace.png";